import { Injectable } from '@angular/core';
import { createSelector, select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { TraceListEntity } from '../components/trace-list/trace-list.entity';
import { featureSelector, TraceRootState } from './feature.store';
import { TraceOriginalSliceState, TraceSliceKey } from './trace.state';

const baseSelector = createSelector(
	featureSelector,
	(state) => state[TraceSliceKey]
);

@Injectable()
export class TraceSelector {
	public constructor(private readonly store: Store<TraceRootState>) {}

	private get state(): Observable<TraceOriginalSliceState> {
		return this.store.pipe(select(baseSelector));
	}

	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getTraceList$(): Observable<TraceListEntity> {
		return this.state.pipe(map((state) => state.get('list')));
	}

	public getTotal$(): Observable<number> {
		return this.state.pipe(map((state) => state.get('total')));
	}
}
